/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BasicClaimInfo
 */
export interface BasicClaimInfo {
    /**
     * 
     * @type {string}
     * @memberof BasicClaimInfo
     */
    claimNumber: string;
    /**
     * 
     * @type {string}
     * @memberof BasicClaimInfo
     */
    claimPosition: string;
    /**
     * 
     * @type {string}
     * @memberof BasicClaimInfo
     */
    claimantName: string;
    /**
     * 
     * @type {string}
     * @memberof BasicClaimInfo
     */
    policyNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof BasicClaimInfo
     */
    lossLocation: string | null;
    /**
     * 
     * @type {string}
     * @memberof BasicClaimInfo
     */
    customerReferenceNumber: string | null;
}

/**
 * Check if a given object implements the BasicClaimInfo interface.
 */
export function instanceOfBasicClaimInfo(value: object): value is BasicClaimInfo {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('claimPosition' in value) || value['claimPosition'] === undefined) return false;
    if (!('claimantName' in value) || value['claimantName'] === undefined) return false;
    if (!('policyNumber' in value) || value['policyNumber'] === undefined) return false;
    if (!('lossLocation' in value) || value['lossLocation'] === undefined) return false;
    if (!('customerReferenceNumber' in value) || value['customerReferenceNumber'] === undefined) return false;
    return true;
}

export function BasicClaimInfoFromJSON(json: any): BasicClaimInfo {
    return BasicClaimInfoFromJSONTyped(json, false);
}

export function BasicClaimInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BasicClaimInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'claimPosition': json['claimPosition'],
        'claimantName': json['claimantName'],
        'policyNumber': json['policyNumber'],
        'lossLocation': json['lossLocation'],
        'customerReferenceNumber': json['customerReferenceNumber'],
    };
}

export function BasicClaimInfoToJSON(value?: BasicClaimInfo | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'claimPosition': value['claimPosition'],
        'claimantName': value['claimantName'],
        'policyNumber': value['policyNumber'],
        'lossLocation': value['lossLocation'],
        'customerReferenceNumber': value['customerReferenceNumber'],
    };
}

